// export const temp_url = "https://pms.suryapms.com/Admin/public/api/";
// export const base_url = "https://pms.suryapms.com/Admin/public/api/";

// export const temp_url = "http://192.168.18.38/api/";
// export const base_url = "http://192.168.18.38/api/";

// export const temp_url = 'http://192.168.18.38/property_mangement/v1/api/';
// export const base_url = 'http://192.168.18.38/property_mangement/v1/api/';
// export const PathUrl = "https://pms.suryapms.com/Admin/public";




export const base_url = "https://pms.alisonstech-dev.com/Admin/public/api/";
export const temp_url = "https://pms.alisonstech-dev.com/Admin/public/api/";
export const PathUrl = "https://pms.alisonstech-dev.com/Admin/public/";

// export const PathUrl = "http://192.168.18.38/";

// export const base_url = "http://192.168.18.227:99/property/public/api/";
// export const temp_url = "http://192.168.18.227:99/property/public/api/";
// export const PathUrl = "http://192.168.18.227:99/property/public";

export const encryptionSecret = "2d84n0OiymE6eQtvCsdfdstett5zQmm2OsP";





export const logInApii = "login";
export const ForgetPassword = "forgot_password/sendCode";
export const ChangePassword = "password/changePassword";
export const VerifyOTP = "forgot_password/verifyCode";
export const registerBrandOwner = "Brand/create";
export const registerRollsApi = "Role/create-role";
export const editRoleAPI = "Role/Update";
export const registerbranduser = "User/register";
export const allUsersApi = "User/get";
export const usersStatusUpdateApi = "User/update";
export const edituserapis = "User/update";
export const assinPreDeatilsss = "AssignFlat/get/";

// <--------------- REPORTS ------------------->

export const allreportApi = "Reports/overAll";
export const reportBynonthapi = "Reports/monthly";
export const reportbypaymentapi = "Reports/payment";
export const reportbyclientapi = "Reports/all/client";
export const reportbypropertyyyapi = "Reports/property";
export const reeportbyyyflatspremieses = "Reports/flat";

// --------------- Dashboard ------------------------->

export const getAllDashboard = "Property/get";
export const NotificationGetAll = "Notifications/get";
export const removeNotification = "Notifications/read";
export const filterpremises = "Flat/get";

// --------------- Dashboard  ------------------------->
// <--------------- property type ------------------->
export const getAllPropertyType = "domainparmeter/Property/type/get";
export const getAllActivePropertyType =
  "domainparmeter/Property/type/get/active";
export const createPropertyType = "domainparmeter/Property/type/create";
export const updatePropertyType = "domainparmeter/Property/type/update";
export const updateStatusPropertyType = "domainparmeter/Property/type/";
export const tenantDleteee = "Client/delete?id=";
export const premiseDeletedd = "Flat/delete?id=";
export const ProperrtydEletee = "Property/delete?id=";
// <--------------- property type ------------------->

// --------------- Flat Size ------------------------->
export const getAllAmenitiesType = "domainparmeter/amenities/get";
export const getAllActiveAmenities = "domainparmeter/amenities/get/active";
export const createAmenitiesType = "domainparmeter/amenities/create";
export const updateAmenitiesType = "domainparmeter/amenities/update";
export const updateStatusAmenitiesType = "domainparmeter/amenities/";
// --------------- Flat Size ------------------------->

// --------------- Flat Size ------------------------->
export const getAllFlatSize = "domainparmeter/size/get";
export const getAllActiveFlatSize = "domainparmeter/size/get/active";
export const createFlatSize = "domainparmeter/size/create";
export const updateFlatSize = "domainparmeter/size/update";
export const updateStatusFlatSize = "domainparmeter/size/";
// --------------- Flat Size ------------------------->
// --------------- Flat  ------------------------->
export const getAllFlat = "Flat/get";
export const getAllFlatProperty = "Flat/get/all";
export const getAllActiveFlat = "Flat/get/active";
export const createFlat = "Flat/create";
export const updateFlat = "Flat/update";
export const updateStatusFlat = "Flat/";
// --------------- Flat  ------------------------->
// --------------- Maintenance  ------------------------->
export const getAllMaintenanceType = "MaintenanceType/get";
export const getAllMaintenance = "Maintenance/get";
export const createmaintenance = "MaintenanceType/create";
export const createAllmaintenance = "Maintenance/create";
export const updatAllmaintenance = "Maintenance/update";
export const updateMaintenance = "MaintenanceType/";
export const editMaintenanceType = "MaintenanceType/update";
export const activeMaintenanceType = "MaintenanceType/get/active";
export const updateStatusMaintenance = "Maintenance/";

// --------------- Maintenance  ------------------------->

// --------------- TAXES  ------------------------->
export const getAllTaxes = "domainparmeter/tax/get";
export const createTaxes = "domainparmeter/tax/create";
export const updateTaxes = "domainparmeter/tax/update";
export const updateStatusTaxes = "domainparmeter/tax/";
export const getAllActiveTax = "domainparmeter/tax/get/active";
// --------------- TAXES  ------------------------->

// --------------- Propperty  ------------------------->

export const createAllProperty = "Property/create";
export const updateAllProperty = "Property/update";
export const getAllActiveProperty = "Property/get/active";
export const getAllProperty = "Property/get";

// --------------- Propperty  ------------------------->

// --------------- CLIENT  ------------------------->

export const createCLienApi = "Client/create";
export const fetchgetclientapi = "Client/get";
export const editclinetapi = "Client/update";
export const createfetchassignproperty = "AssignFlat/create";

// --------------- CLIENT  ------------------------->

// <-------------- PAYMENT ------------------------->
export const paymentUniqueId = "AssignFlat/unique/";
export const createPayment = "Payment/create";
export const getPayment = "Payment/get";

// <-------------- PAYMENT ------------------------->

// <-------------- Users ------------------------->

export const createUsers = "user_management/create";
export const updateUsers = "user_management/update";
export const getAllUsers = "user_management/get";

// <-------------- Users ------------------------->

//<--------------- Notifications ------------------------------>

export const getAllNotification = "domainparmeter/get/notifications";

//<--------------- Notifications ------------------------------>

// ----------------------------------------------------------------ETIBAR_WINS----------------------------------------------------------------

export const assignpermissionapiGet = "AssignFlat/get";

export const allRoleApi = "Role/get-roles";
export const assignpermissionsApi = "Permission/assign-permission";
export const getRolePermissionsApi = "Permission/get-rolepermissions";
export const allpermissionsApi = "Permission/get-allpermissions";

// -------------------------------------------------------------

// -------------------------------------------------------------

// --------------------------------------------------------Deleted-----------------------------------------------------------

// export const allDropdownActiveBrand = 'Brand/get/active';
// export const updateVerfiyLimit = 'Products/updateVerfiyLimit';
// export const registerProduct = 'Products/create';

//---------------------------------------------------------------SMS
// export const getSms = 'sms/get';
// export const createSMS = 'Replay/store';
//--------------------------------------------------------------smsReply
// export const smsReply = 'Reply/getAll';
// export const createsmsReply = 'Reply/store';
// export const editsmsReply = 'Reply/edit';
// export const StatusSmsReply = 'Reply/update';
//------------------------------------------------------------FAQs And Terms
// export const UpdateFAQs = 'faqs/update';
// export const UpdateTerms = 'Terms/update';
// export const GetFAQs = 'faqs';
// export const GETTerms = 'Terms';
// export const Progressive = 'http://etibarwins.com:5000/progress/';
//----------------------------------------------------------------Reports
export const SmsReport = "Report/sms";
export const ReportProblem = "ReportProblem";
export const MapApi = "Report/qr/map";
// export const QrcodeReport = 'Report/qr';

//----------------------------------------------------------------ColorShift
// export const ColorShift = 'getColorShifting';
// export const getColorShift = 'getColorShiftingWeb';

//------------------------------------------------------------------csv files
// export const csv_url = 'RandomCodes/csv';
// export const csv_file = 'https://etibarwins.com/Admin/downloadFile/';
//--------------------------------------------------------------------------- Batches

export const GetAllBatch = "Batches/getAll";
// export const batchStatusUpdate = 'Batches/update';
// export const batchProductSerialNo = 'Batches/Product/availableSerialNo/';
// export const getBatchByProductID = 'Batches/getBatchesByProduct/';
// export const postBatchAPI = 'Batches/create';
export const postUpdateBatchAPI = "Batches/update";

//---------------------------------------------------------------------------
export const companygetall = "Company/getAll";
// export const createcompany = 'Company/register';
export const companystatusupdate = "Company/update";
export const companydetailing = "Company/get";
//---------------------------------------------------------------------------

// export const editingcategory = 'Category/update';
// export const allsubcategroiess = 'SubCategory/index';
export const subcategoryupdatestatus = "SubCategory/status-update";
export const subcategoryEdit = "SubCategory/update";
// export const createSubcategory = 'SubCategory/store';
// export const postRandomCodes = 'PrePost/store';

// ---------------------------------------------------------------Deleted---------------------------------------------------------------

export const allProductApi = "Products/getAll";
export const allProductActiveApi = "Products/get/active";
export const ProductStatusUpdateApi = "Products/update";
export const editProductApi = "Products/update";
export const brandupdatestatusApi = "Brand/update";
export const getAllBrands = "Brand/getAll";
export const brandeditapi = "Brand/get";
export const getsallcategeory = "Category/index";
export const update_status_code = "RandomCodes/update-status";
export const updatestatuscategory = "Category/status-update";
export const cateapplyregister = "Category/store";

export const getAllCounts = "Dashboard/get/count";
export const getRandomCodes = "RandomCodes/index";
